var map = {
	"./symbol_0.png": 78841,
	"./symbol_1.png": 72592,
	"./symbol_2.png": 86411,
	"./symbol_3.png": 95906,
	"./symbol_4.png": 57629,
	"./symbol_5.png": 36500,
	"./symbol_6.png": 41615,
	"./symbol_7.png": 76422,
	"./symbol_8.png": 87937,
	"./symbol_9.png": 66808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85972;